/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { RadioContainer, RadioCircle, RadioLabel, Error } from './style'

const RadioButton = ({ name, value, checked, onChange, label, disabled = false, error, field, dataTest, notNull }) => {
  return (
    <>
      <RadioContainer data-testid={dataTest || 'test-radio'} disabled={disabled}>
        <RadioCircle
          checked={checked}
          disabled={disabled}
          onClick={() => {
            if (disabled) return
            if (checked && notNull) return
            onChange(checked ? null : value)
          }}
        />
        <RadioLabel
         onClick={() => {
            if (disabled) return
            if (checked && notNull) return
            onChange(checked ? null : value)
          }}
        >{label}</RadioLabel>
      </RadioContainer>

      {error && error.field === field && (
        <Error data-test="validation-error-message">
          <FormattedMessage id={error.error} />
        </Error>
      )}
    </>
  )
}

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.node,
  disabled: PropTypes.bool,
  error: PropTypes.shape({
    field: PropTypes.string,
    error: PropTypes.string
  }),
  field: PropTypes.string,
  dataTest: PropTypes.string
}

export default RadioButton
